var React = require('react');
var DateFormatter = require('../../Formatters/DateFormatter');
var PriceFormatter = require('../../Formatters/PriceFormatter');

var style ={
	container: {
		display: 'flex',
		justifyContent: 'space-between',
		borderBottom: 'solid 1px #ccc',
		padding: '5px 0px',
		alignItems: 'center'
	},

	box: {
		display: 'flex',
		flexDirection: 'column',
	}
};

var TotalOrders = React.createClass({
	render: function() {
		var me = this;

		return (
			<div style={style.container}>
				<div style={style.box}>
					<span>
						<span><b>{"Valor total: "} </b> <PriceFormatter data={me.props.value} /></span>
					</span>
				</div>
			</div>
		);
	}

});

module.exports = TotalOrders;


// WEBPACK FOOTER //
// ./src/components/Client/MyOrders/TotalOrders.jsx